import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CustomerDetails } from '../check-in/check-in.interfaces';
import type { RootState } from '../extension-store/extension.store';
import { BaseInitialState, StateStatus } from '../extension-store/interfaces/extension-store.interfaces';

export enum CustomerTier {
  UNLICENSED = 'unlicensed',
  PREMIUM = 'premium',
}

export interface InitialCustomerState extends BaseInitialState {
  customerSettings?: CustomerDetails;
}

const initialState: InitialCustomerState = {
  error: null,
  status: StateStatus.IDLE,
};

export const CustomerSettingsState = createSlice({
  name: 'CustomerSettingsReducer',
  initialState,
  reducers: {
    setCustomerSettings: (mutableState, action: PayloadAction<CustomerDetails>) => {
      mutableState.status = StateStatus.SUCCESS;
      mutableState.customerSettings = action.payload;
    },
  },
});

export const { setCustomerSettings } = CustomerSettingsState.actions;
export const getCustomerSettings = (state: RootState) => state.customerState.customerSettings;
